import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import status from './status';
import map from './map';
import mapV2 from './mapV2';
import spot from './spot';
import units from './units';
import animations from './animations';
import subregion from './subregion';
import worldTaxonomy from './worldTaxonomy';
import components from './components';
import sessions from './sessions';
import swellEvents from './swellEvents';
import deviceData from './deviceData';
import buoys from './buoys';

/**
 * @param {import('history').History} history
 * @param {{[key: string]: import('redux').Reducer}} asyncReducers
 */
const rootReducer = (history, asyncReducers) =>
  combineReducers({
    map,
    mapV2,
    units,
    router: connectRouter(history),
    status,
    animations,
    spot,
    sessions,
    subregion,
    worldTaxonomy,
    components,
    swellEvents,
    deviceData,
    [buoys.path]: buoys.reducer,
    ...asyncReducers,
  });

export default rootReducer;
